import React from "react";
import {Chip, ChipType} from "@bounce/shared/ui";
import {useGetSegments} from "../../apis/requests/segments/getSegments";
import {SegmentCategoryMarker} from "./SegmentCategoryMarker";

type Props = {
  name: string;
  variant: ChipType["variant_"];
};

export const SegmentNameChip = ({name, variant}: Props) => {
  const {data: segments} = useGetSegments();
  const segmentCategory = segments?.find((segment) => segment.name === name)?.segment_category;
  return (
    <Chip
      size_="small"
      variant_={variant}
      label={name}
      icon={segmentCategory ? <SegmentCategoryMarker segmentCategory={segmentCategory} /> : undefined}
      sx={{"& .MuiChip-icon": {ml: "8px", mr: "-2px"}}}
    />
  );
};
